import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import axios from 'axios';
import '../../App.css';
import ResearchSidebar from '../../Components/ResearchSidebar';
import { API_BASE_URL } from '../../utils/apiConfig.js';
const DataDetails = () => {
    const { sessionId } = useParams();
    const [data, setData] = useState({ order: null, events: [], popupResponses: [] });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchSessionDetails = async () => {
            try {
                const response = await axios.get(`${API_BASE_URL}/api/session-details/${sessionId}`);
                setData(response.data);
            } catch (err) {
                console.error("Error fetching details:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchSessionDetails();
    }, [sessionId]);

    if (loading) return <div className="dashboard-layout"><ResearchSidebar /><div className="dashboard-content">Loading...</div></div>;

    // Helper to safely parse JSON or return the object if already parsed
    const safeParse = (data) => {
        if (typeof data === 'string') {
            try { return JSON.parse(data); } catch (e) { return {}; }
        }
        return data || {};
    };

   // Data descriptions for the differen events
    const getEventDescription = (event) => {
        const details = safeParse(event.eventData);
        const target = event.eventTarget;

        switch (target) {
            case 'Nutrition Filter Toggle':
            case 'Category Nutrition Filter Toggle':
                return `Filter: "${details.filterLabel || 'All Products'}"`;
            
            case 'Category Filter':
            case 'Category Toggle':
                return `Category: "${details.category || details.to || 'Unknown'}"`;

            case 'Aisle Filter':
                return `Aisle: "${details.aisle}" in ${details.category}`;

            case 'Product Card Image/Title':
            case 'Search Result Item Click':
            case 'Quick Nutrition Open':
                return `Viewed: "${details.productName || details.clickedProduct}"`;

            case 'Add to Cart':
            case 'Add to Cart (Category View)':
                return `Added to Cart: "${details.productName}"`;

            case 'Navbar Search Bar':
            case 'Search Query':
                return `Searched for: "${details.query || details.searchTerm}"`;

            case 'Category Carousel Scroll':
                return `Scrolled Categories: ${details.direction}`;
            
            case 'Pagination':
                return `Flipped to ${details.direction} page (Target: ${details.targetPage})`;

            default:
                // Fallback: If we don't have a special case, show the target name
                return target;
        }
    };

    // Helper to calculate the difference between the first and last interaction
    const calculateDuration = (events) => {
        if (events.length < 2) return "0:00";
        const start = new Date(events[0].createdAt);
        const end = new Date(events[events.length - 1].createdAt);
        const durationMs = end - start;
        const minutes = Math.floor(durationMs / 60000);
        const seconds = ((durationMs % 60000) / 1000).toFixed(0);
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };

    // Calculate stay duration for specific timeline blocks
    const getStayDuration = (startTime, nextTime) => {
        if (!startTime || !nextTime) return null;
        const diff = new Date(nextTime) - new Date(startTime);
        const mins = Math.floor(diff / 60000);
        const secs = ((diff % 60000) / 1000).toFixed(0);
        return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
    };

    const totalTime = calculateDuration(data.events);

    // Building the Unified Timeline
    const timeline = [];
    let currentGroup = null;

    data.events.forEach((event, index) => {
        if (event.eventType === 'PAGE_VIEW') {
            // If there's an existing group, calculate how long they stayed before this new page view
            if (currentGroup) {
                currentGroup.stayDuration = getStayDuration(currentGroup.pageEvent.createdAt, event.createdAt);
            }
            // Start a new group for this page
            currentGroup = { pageEvent: event, interactions: [], stayDuration: null };
            timeline.push(currentGroup);
        } else if (currentGroup && (event.eventType === 'CLICK' || event.eventType === 'SEARCH'
                                || event.eventType === 'POPUP_VIEW' || event.eventType === 'POPUP_SUBMIT'
                                || event.eventType === 'POPUP_DISMISS' || event.eventType === 'POPUP_NAVIGATE'
        )) {
            // Add interactions to the current page group
            currentGroup.interactions.push(event);
        }
    });

    return (
        <main className="dashboard-layout">
            <ResearchSidebar />
            <div className="dashboard-content">
                <h1 className="page-title">Session Details</h1>
                
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    <h3 style={{ color: '#666', fontSize: '1rem', margin: 0 }}>ID: {sessionId}</h3>
                    <div style={{ 
                        padding: '8px 15px', 
                        backgroundColor: '#e8f5e9', 
                        color: '#056621', 
                        borderRadius: '20px', 
                        fontWeight: 'bold',
                        border: '1px solid #c8e6c9'
                    }}>
                        Total Active Time: {totalTime} min
                    </div>
                </div>
                
                <div className="details-container">
                    <h2 style={{ fontSize: '1.2rem', color: '#333', marginBottom: '15px' }}>Behavioral Timeline</h2>
                    
                    {timeline.length > 0 ? (
                        <div className="timeline-wrapper">
                            {timeline.map((group, idx) => {
                                const pageData = safeParse(group.pageEvent.eventData);
                                return (
                                    <div key={idx} className="timeline-block" style={{ marginBottom: '30px', borderLeft: '3px solid #056621', paddingLeft: '15px' }}>
                                        <div className="timeline-header" style={{ marginBottom: '10px' }}>
                                            <strong style={{ color: '#056621', fontSize: '1.1rem' }}>
                                                → {group.pageEvent.eventTarget}
                                            </strong>
                                            {pageData.pageNumber && <span style={{ color: '#666' }}> (Page {pageData.pageNumber})</span>}
                                            {group.stayDuration && (
                                                <span style={{ marginLeft: '15px', fontSize: '0.9rem', color: '#666', fontStyle: 'italic' }}>
                                                    Stayed for {group.stayDuration} min
                                                </span>
                                            )}
                                        </div>

                                        <ul style={{ listStyle: 'none', padding: 0 }}>
                                            {group.interactions.map(interaction => {
                                                return (
                                                    <li key={interaction.eventId} style={{ marginBottom: '5px', fontSize: '0.95rem', color: '#444' }}>
                                                        <span style={{ color: '#999', marginRight: '10px' }}>
                                                            {new Date(interaction.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
                                                        </span>
                                                        <strong>[{interaction.eventType}]</strong> {getEventDescription(interaction)}
                                                    </li>
                                                );
                                            })}
                                            {group.interactions.length === 0 && (
                                                <li style={{ color: '#999', fontSize: '0.85rem' }}>No interactions on this page.</li>
                                            )}
                                        </ul>
                                    </div>
                                );
                            })}
                        </div>
                    ) : <p>No behavioral timeline data available.</p>}

                    {/* Popup Responses */}
                    <details className="data-details-section" open style={{ marginTop: '40px' }}>
                        <summary>Popup Responses</summary>
                        <div className="section-content">
                            {data.popupResponses ? (
                                <>
                                    <ul className="details-list" style={{ listStyle: 'none', padding: 0 }}>
                                        {safeParse(data.popupResponses).map((popup, index) => (
                                            <li key={index} style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                                                <strong>{popup.popupName}</strong> — {popup.response}
                                            </li>
                                        ))}
                                    </ul>
                                </>
                            ) : (
                                <div style={{ padding: '10px', color: '#666', fontStyle: 'italic' }}>
                                    No popups submitted for this session.
                                </div>
                            )}
                        </div>
                    </details>

                    {/* Section 3: Final Order Content */}
                    <details className="data-details-section" open style={{ marginTop: '40px' }}>
                        <summary>Final Order Content</summary>
                        <div className="section-content">
                            {data.order ? (
                                <>
                                    <ul className="details-list" style={{ listStyle: 'none', padding: 0 }}>
                                        {safeParse(data.order.orderItems).map((item, index) => (
                                            <li key={index} style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                                                {item.quantity}x {item.item.name} — ${(item.item.price * item.quantity).toFixed(2)}
                                            </li>
                                        ))}
                                    </ul>
                                    <div className="order-total-line" style={{ borderTop: '2px solid #056621', marginTop: '15px', paddingTop: '10px', textAlign: 'right' }}>
                                        <strong style={{ fontSize: '1.2rem' }}>
                                            Total Price: ${parseFloat(data.order.totalAmount || 0).toFixed(2)}
                                        </strong>
                                    </div>
                                </>
                            ) : (
                                <div style={{ padding: '10px', color: '#666', fontStyle: 'italic' }}>
                                    No checkout completed for this session.
                                </div>
                            )}
                        </div>
                    </details>
                </div>
            </div>
        </main>
    );
};

export default DataDetails;